const hotel = {
  availableMealPlans: "可用的膳食计划", // translated
  availableRoomsTypes: "可用的房间类型", // translated
  cancellationPolicy: "取消政策", // translated
  cancellationRules: "取消规则", // translated
  freeCancellationAvailable: "可免费取消", // translated
  nonRefundable: "不退还", // translated
  priceFor: "价格为", // translated
  nights: "夜晚", // translated
  totalPrice: "总价", // translated
  seeAvailability: "查看空房情况", // translated
  myProfile: "我的账户", // translated
  travelTrust: "旅游信托", // translated
  signIn: "登入", // translated
  searchNow: "现在搜索", // translated
  policy: "政策", // translated
  cxlRules: "CXL规则", // translated
  room: "房间", // translated
  cxlPolicy: "CXL政策", // translated
  beddingType: "床品类型", // translated
  hotelName: "酒店名称", // translated
  reservationDate: "预订日期", // translated
  maxPax: "最大人数", // translated
};

export default hotel;
